import { render } from "./initial-info-update.vue?vue&type=template&id=10a761c7&scoped=true"
import script from "./initial-info-update.vue?vue&type=script&lang=js"
export * from "./initial-info-update.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./initial-info-update.vue?vue&type=style&index=1&id=10a761c7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a761c7"]])

export default __exports__